import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import FileService from "../services/file.service";
import * as TbIcons from 'react-icons/tb';
import * as AiIcons from 'react-icons/ai';
import AuthService from "../services/auth.service";
import AxiosService from "../services/axios.service";

const API_PATH = "attorneys";

function ViewAtt({ history, match }) {

  const [attorney, setAttorney] = useState([]);
  const { id } = match.params;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const API_URL = "https://db.irli.org/api/files/";

  const styles = {
    div: {
      whiteSpace: "pre-line"
    }
  }

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.get(API_PATH, id).then(x => {
      var attorney = x.data;
      // console.log(attorney);
      //   var str_courts = "";
      //   var courts = attorney.courts
      //   lawsuit.case_name += lawsuit.attorney.id ? (", " + lawsuit.name) : "";
      //   for (var i in courts) {
      //       str_courts += "(" + (courts[i].abbreviation) + ") "; //comma if there is more
      //   }
      //   lawsuit.case_name += str_courts ? (", " + str_courts) : str_courts;
      setAttorney(attorney);
      console.log(attorney.data);
      var documents = [];
      documents = attorney.documents;
      FileService.getFiles().then((response) => {
        var files = [];
        for (var x in documents) {
          var file = new Object();
          file.name = documents[x];
          file.url = API_URL + file.name;
          files.push(file);
        }
        console.log("file infos: " + JSON.stringify(files));
        //setFileInfos(files); // previously response.data
      });
    });
  }, []);

  return (

    <div>
      <h1 style={{ marginBottom: 25 }}>{attorney.name}</h1>
      <table class="table">
        <div >
          <button style={{ position: 'sticky', left: 0, top: 25, zIndex: 1 }} onClick={() => history.goBack()}><TbIcons.TbArrowBack color='black' size={38} /></button>

        </div>
        <div style={{ position: 'sticky' }}>
          {(mod || admin) && (
            <Link to={`../edit/${id}`} style={{ position: 'relative', left: 0, top: -1, marginTop: 15 }} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
          )}
        </div>
        <thead>
          <tr>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">Attorney Name:</th>
            <td>{attorney.name}</td>
          </tr>
          <tr>
            <th scope="row">Attorney DB ID:</th>
            <td>{attorney.id}</td>
          </tr>
          <tr>
            <th scope="row">Phone Number:</th>
            <td style={styles.div}>
              {attorney.phone}
            </td>
          </tr>
          <tr>
            <th scope="row">Attorney Email:</th>
            <td>{attorney.email}</td>
          </tr>

          <tr>
            <th scope="row">Street Address:</th>
            <td style={styles.div}>{attorney.street_address}</td>
          </tr>

          <tr>
            <th scope="row">City:</th>
            <td style={styles.div}>{attorney.city}</td>
          </tr>

          <tr>
            <th scope="row">State:</th>
            <td style={styles.div}>{attorney.state}</td>
          </tr>

          <tr>
            <th scope="row">Zip Code:</th>
            <td style={styles.div}>{attorney.zip}</td>
          </tr>

          <tr>
            <th scope="row">Date Admitted:</th>
            <td style={styles.div}>{attorney.admitted}</td>
          </tr>

          <tr>
            <th scope="row">Pratice area:</th>
            <td style={styles.div}>{attorney.practice_area}</td>
          </tr>

          <tr>
            <th scope="row">Month/Yr Joined</th>
            <td style={styles.div}>{attorney.month_year_joined}</td>
          </tr>
          <tr>
            <th scope="row">Lat</th>
            <td style={styles.div}>{attorney.latitude}</td>
          </tr>
          <tr>
            <th scope="row">Lng</th>
            <td style={styles.div}>{attorney.longitude}</td>
          </tr>
        </tbody>
      </table>
    </div >
  );

}

export { ViewAtt };